var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.0714C4.33333 14.0714 3 14.5 3 16.2143C3 17.9286 4.33333 18.3571 5 18.3571H19C19.6667 18.3571 21 17.9286 21 16.2143C21 14.5 19.6667 14.0714 19 14.0714M5 14.0714C5.16667 12.6429 5.6 10.1071 6 9.25C6.69843 7.37922 8.37245 6.29239 10 5.80702M5 14.0714H7M19 14.0714C19 12.8214 18.7475 10.4513 18 9.25C16.836 7.37922 15.3954 6.29239 13.917 5.80702M19 14.0714H17M10 5.80702C10.7028 5.59744 11.3969 5.5 12 5.5C12.6332 5.5 13.2786 5.59744 13.917 5.80702M10 5.80702V11.3929M13.917 5.80702V11.3929",
    stroke: "#878F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.f2059c91798c217c05453dca7d948b03.svg";
export { ForwardRef as ReactComponent };